import React, {useState} from "react"
import { useDispatch, useSelector } from 'react-redux'
import { updateEvent } from '../../state/events'
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import Tooltip from "react-bootstrap/Tooltip"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"


const StatusOrbs = ({ event_id, event_type, complete, firstGif, setFirstGif }) => {
	const isClient = useSelector(state => state.users.current_user.account_type) === "client"

	// Event Success Modal
	const [evtSuccessModal, setEvtSuccessModal] = useState(false);

	const handleCloseEvtSuccessModal = () => setEvtSuccessModal(false);

	const dispatch = useDispatch()
	const options = [
		{
			color: 'success',
			complete: "1"
		}, {
			color: 'primary',
			complete: "0"
		}, {
			color: 'danger',
			complete: "2"
		}
	]

	function tooltipContent(color) {
		if (color === "success") {
			return "Mark Complete"
		} else if (color === "primary") {
			return "Mark Open"
		} else {
			return "Mark Not Met"
		}
	}

	return (
		<div className="d-flex align-items-center justify-content-between my-1 flex-wrap">
			<small className="mr-2">status:</small>
			<div className="d-flex align-items-center">
				{options.map((opt, i) => {
					return (

						<>
							<OverlayTrigger
								placement="top"
								delay={{ show: 250, hide: 100 }}
								overlay={
									<Tooltip id="button-tooltip">
										{tooltipContent(opt.color)}
									</Tooltip>}>
								<button
									key={opt.color}
									onClick={(e) => {
										if (opt.color === "success") {
											if (firstGif && isClient) {
												setEvtSuccessModal(true);
												setFirstGif(false)
											}
										}
										dispatch(updateEvent({
											event_type,
											event_id,
											complete: opt.complete
										}))
										// otherwise tooltip stay visible on click
										e.target.blur();
									}}
									className={[
										complete == opt.complete ? `bg-${opt.color}` : '',
										`border border-${opt.color}`
									].join(' ')}
									style={{
										width: '16px',
										height: '16px',
										flex: '0 0 auto',
										display: 'block',
										marginRight: '4px',
										cursor: 'pointer',
										borderRadius: '100%'
									}}>
								</button>
							</OverlayTrigger>
						</>
					)
				})}
			</div>
			{/* Event Success Modal */}
			<Modal show={evtSuccessModal} onHide={handleCloseEvtSuccessModal}>
				<Modal.Body className="mx-auto"> <img style={{ maxWidth: "300px" }} src="https://cdn.fitsw.com/assets/img/badges/HighFive.gif" /> </Modal.Body>
				<Modal.Footer>
					<Button variant="primary" onClick={handleCloseEvtSuccessModal}>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		</div >
	)
}

export default StatusOrbs